/** `12s`, `4m`, `3h`, `2d` since `ms`. */
export function ago(ms: number, now = Date.now()): string {
  const seconds = Math.max(0, Math.floor((now - ms) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

/** `29d 23h`, `4h 12m`, `3m` until `ms`. */
export function until(ms: number, now = Date.now()): string {
  const seconds = Math.max(0, Math.floor((ms - now) / 1000));
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

/** `14:02:09` local. */
export function clock(ms: number): string {
  return new Date(ms).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
}

/** `14 Oct 2026`. */
export function day(ms: number): string {
  return new Date(ms).toLocaleDateString([], { day: "numeric", month: "short", year: "numeric" });
}
